<app-landing-page-register
    title="Request a free demo"
    subtitle="LandingPageDemoFlavorText"
    isDemoRequest
    successTitle="DemoRequestSuccessTitle"
    successSubtitle="DemoRequestSuccessText"
></app-landing-page-register>
